import React from 'react'

const Plus = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 23 23' {...props}>
    <path d='M21.5 10.5h-9v-9c0-.6-.4-1-1-1s-1 .4-1 1v9h-9c-.6 0-1 .4-1 1s.4 1 1 1h9v9c0 .6.4 1 1 1s1-.4 1-1v-9h9c.6 0 1-.4 1-1s-.4-1-1-1z' />
  </svg>
)

export default Plus
